import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';
import { PaywallProps } from '@components/Paywall';
import { AppContextProvider, Env } from '@contexts/AppContext';
import { Author } from '@interfaces/authors';
import { Article, MostPopularArticle } from '@interfaces/homepage';
import { User } from '@utils/backend-api/currentUser';

import BriefingContent from './BriefingContent';

export type BriefingPaywallProps = Omit<PaywallProps, 'articleId' | 'shareGuid' | 'trackingProps'>;

export interface BriefingType {
  authors?: Author[];
  body: string;
  commentsCount: number;
  contentType: 'Briefing';
  featuredEntityTopic?: string;
  headline: string;
  id: number;
  publishedAt: string;
  relatedItems?: ArticleOrBriefing[];
  slug: string;
  source?: BriefingSource;
}

export interface BriefingSource {
  name: string;
  url: string;
}

export interface BriefingProps {
  briefing: BriefingType;
  canViewFullBriefing: boolean;
  currentUserPresent: boolean;
  env: Env;
  hideAwarenessBar: boolean;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
  isSEOBot: boolean;
  mostPopularArticles: MostPopularArticle[];
  paywallProps?: BriefingPaywallProps;
  relatedArticles: Article[];
  teaser: string;
}

const queryClient = new QueryClient();

const Briefing = (props: BriefingProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <BriefingContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Briefing;
